const customValidator = {
  validateDependantRequiredColumn: (entityName, columnName, currentColumn, currentColumnValue, data, otherFieldsToConsider, errors) => {
      let result = true;

      if (
        currentColumn.label === columnName &&
        (!currentColumnValue || currentColumnValue.trim() === '') &&
        data &&
        (
          otherFieldsToConsider &&
          otherFieldsToConsider(data)
        )) {
        result = false;
        errors.push(`${columnName} is a required field for ${entityName}`);
      }

      return result;
    }
};

export default customValidator;
